/**
 * 가입 정책 스위치(2026-10-05, 사용자 결정 '중간안').
 *
 * MARKETING_CONSENT_OPTIONAL — 가입 화면의 마케팅 수신 동의를 선택으로 할지.
 *   true 로 바꾸기 전에 공용 가입 서버(docu-spring, DocuAI 와 같이 씀)가 동의 없는 가입을 받아들여야 한다:
 *   AuthOtpController(이메일 가입)·AuthOAuthController(SNS 가입 완료)의 `agreeMarketing` 필수 검사를 빼는 것.
 *   서버가 바뀌기 전에 화면만 선택으로 하면 서버가 가입을 거절한다. 인수인계: docs/2026-10-05-마케팅동의-선택화-가입서버-변경요청.md
 *
 * 무료 체험(첫 사용부터 1개월)은 스위치와 관계없이 마케팅 수신 동의자에게만 열린다(loginHS 서버 EntitlementService).
 */
export const MARKETING_CONSENT_OPTIONAL = false;
